import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicCategoryVm } from '../operator-elearning-topic-category-vm.model';
import { IOperatorElearningTopicCategoryIm } from '../operator-elearning-topic-category-im.model';
import { IOperatorElearningTopicCategoryUm } from '../operator-elearning-topic-category-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicCategoryService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicCategory`;
  }
  get(id: number): Observable<IOperatorElearningTopicCategoryVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.get<IOperatorElearningTopicCategoryVm>(this.baseUrl, { headers, params });
  }
  post(operatorElearningTopicCategoryIm: IOperatorElearningTopicCategoryIm): Observable<IOperatorElearningTopicCategoryVm> {
    const headers = this.createHeaders();
    return this.http.post<IOperatorElearningTopicCategoryVm>(this.baseUrl, operatorElearningTopicCategoryIm, { headers });
  }
  put(operatorElearningTopicCategoryUm: IOperatorElearningTopicCategoryUm): Observable<IOperatorElearningTopicCategoryVm> {
    const headers = this.createHeaders();
    return this.http.put<IOperatorElearningTopicCategoryVm>(this.baseUrl, operatorElearningTopicCategoryUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
